import { createRouter, createWebHistory } from 'vue-router'
import axios from 'axios'

//Layouts
import BaseLayout from '@/views/layouts/BaseLayout.vue'
import AdminLayout from "@/views/layouts/AdminLayout.vue";
import LoginClientLayout from '@/views/layouts/LoginClientLayout.vue'

import Login from '@/views/Login.vue'

// Admin
import Dashboard from "@/views/admin/Dashboard.vue"
import UsersList from "@/views/admin/Users/UsersList.vue"
import UsersForm from "@/views/admin/Users/UsersForm.vue"
import CampaignsList from "@/views/admin/WarehousesCampaigns/WarehousesCampaignsList.vue";
import CampaignLinesList from "@/views/admin/WarehousesCampaigns/WarehousesCampaignLinesList.vue";
import StockList from "@/views/admin/Stock/StockList.vue";
import WarehousesList from "@/views/admin/Warehouses/WarehousesList.vue";
import ClientsList from "@/views/admin/Clients/ClientsList.vue";
import StockHistory from "@/views/admin/Stock/StockHistory.vue";
import DeparturesList from "@/views/admin/Departures/DeparturesList.vue";
import DeparturesHistory from "@/views/admin/Departures/DeparturesHistory.vue";
import ProvidersList from "@/views/admin/Providers/ProvidersList.vue";
import Statistics from "@/views/admin/Statistics/Statistics.vue";
import ClientsInfoList from "@/views/admin/ClientInfo/ClientInfo.vue";

// Planimetria
import ReloadPlani from '@/views/admin/Planimetria/ReloadPlani.vue'
import ValidarPlani from '@/views/admin/Planimetria/ValidarPlani.vue'
import EnviarPlani from '@/views/admin/Planimetria/EnviarPlani.vue'
import AlbaransEntrega from '@/views/admin/AlbaransEntrega/AlbaransEntrega.vue'
import DescarregarPlaniXls from '@/views/admin/Planimetria/DescarregarPlaniXls.vue'

//Producció
import EntregasTienda from '@/views/admin/Produccion/EntregasTienda.vue'
import RepartosHoy from '@/views/admin/Produccion/RepartosHoy.vue'
import CampanyasIniciadasSinPlanificar from '@/views/admin/Produccion/CampanyasIniciadasSinPlanificar.vue'

//Magatzem
import MagatzemsRexpedicio from "@/views/admin/WarehousesLists/MagatzemsRexpedicio.vue";
import WarehousesLoad from "@/views/admin/WarehousesLists/WarehousesLoad.vue";
import MagatzemsRexpedicioHibrid from "@/views/admin/WarehousesLists/RepartosProveedoresHibridos.vue";

//KPIs
import KPI from "@/views/admin/kpi/kpis.vue"

// Web Client
// -- Admin
import AdminCampaignWebList from '@/views/admin/WebClient/CampaignList.vue'
// -- Web
import LoginClient from '@/views/web_client/LoginClient.vue'
import CampaignWebList from "@/views/web_client/CampaignsList.vue";
import CampaignsInfo from "@/views/web_client/CampaignsInfo.vue";
import Estadistiques from "@/views/web_client/Estadistiques.vue";
import Estudios from "@/views/web_client/Estudios.vue";

// Documentacio
// -- Admin
import AdminDocumentacio from '@/views/admin/WebClient/Documentacio.vue'
import Mailing from "../views/admin/Mailing/Mailing.vue";
import Kpis from '../views/admin/kpi/kpis.vue';


const routes = [
    {
        path: '/',
        name: 'login',
        component: Login
    },

      {
        path: '/cliente',
        component: LoginClientLayout,
        children: [{ path: '', name: 'LoginClient', component: LoginClient, meta: { requiresAuth: false } },]
        },

    {
        path: '/cliente',
        component: BaseLayout,
        children: [
            { path: ':idClient(\\d+)/:token([A-Za-z0-9]{24})', name: 'CampListToken', component: CampaignWebList, meta: { requiresAuth: false } },
            { path: 'CampList/:shop?/:desc?', name: 'CampList', component: CampaignWebList, meta: { requiresAuth: false } },
            { path: 'CampInfo/:idOdoo/:shop?', name: 'CampInfo', component: CampaignsInfo, meta: { requiresAuth: false } },
            { path: 'Estadistiques', name: 'Estadistiques', component: Estadistiques, meta: { requiresAuth: false } },
            { path: 'Estudios', name: 'Estudios', component: Estudios, meta: { requiresAuth: false } },
        ]
    },

    {
        path: '/dashboard',
        component: AdminLayout,
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                component: Dashboard,
                name: 'dashboard'
            },
            {
                path: 'compres',
                component: () => import('@/views/admin/Compres/CompresList.vue'),
                name: 'compres.index',
                meta: {
                    roles: ['admin', 'compres'],
                    breadcrumb: [
                        { text: 'Inicio', to: '/dashboard' },
                        { text: 'Compres' }
                    ]
                }
            },
            {
                path: 'users',
                component: UsersList,
                name: 'users.index',
                meta: {
                    breadcrumb: [
                        { text: 'Inicio', to: '/dashboard' },
                        { text: 'Usuarios' }
                    ],
                    roles: ['admin']
                }
            },
            {
                path: 'users/create',
                component: UsersForm,
                name: 'users.create',
                meta: {
                    breadcrumb: [
                        { text: 'Inicio', to: '/dashboard' },
                        { text: 'Usuarios', to: '/dashboard/users'},
                        { text: 'Nuevo usuario'}
                    ],
                    roles: ['admin']
                }
            },
            {
                path: 'users/edit/:id',
                component: UsersForm,
                name: 'users.edit',
                meta: {
                    breadcrumb: [
                        { text: 'Inicio', to: '/dashboard' },
                        { text: 'Usuarios', to: '/dashboard/users'},
                        { text: 'Editar usuario'}
                    ],
                    roles: ['admin']
                }
            },
            {
                path: 'mailing',
                component: Mailing,
                name: 'Mailing.index',
                meta: {
                    breadcrumb: [
                        { text: 'Inicio', to: '/dashboard' },
                        { text: 'Mailing' }
                    ],
                    roles: ['admin'] // 👈 restringit a admin (afegeix altres rols si cal)
                }
            },
            {
                path: 'campaigns',
                component: CampaignsList,
                name: 'campaigns.index',
                meta: {
                    breadcrumb: [
                        { text: 'Inicio', to: '/dashboard' },
                        { text: 'Campañas'}
                    ]
                }
            },
            {
                path: 'campaigns/:id/lines',
                component: CampaignLinesList,
                name: 'campaignlines.index',
                meta: {
                    breadcrumb: [
                        { text: 'Inicio', to: '/dashboard' },
                        { text: 'Campañas', to: '/dashboard/campaigns'},
                        { text: 'Líneas de campaña'}
                    ]
                }
            },
            {
                path: 'stock',
                component: StockList,
                name: 'stock.index',
                meta: {
                    breadcrumb: [
                        { text: 'Inicio', to: '/dashboard' },
                        { text: 'Stocks'}
                    ]
                }
            },
            {
                path: 'stocks/history/:description',
                component: StockHistory,
                name: 'StockHistory',
                meta: {
                    breadcrumb: [
                        { text: 'Inicio', to: '/dashboard' },
                        { text: 'Stocks', to: '/dashboard/stocks'},
                        { text: 'Historial'}
                    ]
                }
            },
            {
                path: 'departures',
                component: DeparturesList,
                name: 'departures.index',
                meta: {
                    breadcrumb: [
                        { text: 'Inicio', to: '/dashboard' },
                        { text: 'Salidas'}
                    ]
                }
            },
            {
                path: 'statistics',
                component: Statistics,
                name: 'Statistics.index',
                meta: {
                    breadcrumb: [
                        { text: 'Inicio', to: '/dashboard' },
                        { text: 'Estadisticas'}
                    ],
                    roles: ['admin'] // rol 'warehouse' també
                }
            },
            {
                path: 'departures/history/:provider',
                component: DeparturesHistory,
                name: 'DeparturesHistory',
                meta: {
                    breadcrumb: [
                        { text: 'Inicio', to: '/dashboard' },
                        { text: 'Salidas', to: '/dashboard/departures'},
                        { text: 'Historial'}
                    ]
                }
            },
            {
                path: 'warehouses',
                component: WarehousesList,
                name: 'warehouses.index',
                meta: {
                    breadcrumb: [
                        {text: 'Inicio', to: '/dashboard'},
                        {text: 'Almacenes'}
                    ]
                }
            },
            {
                path: 'warehousesLists',
                component: WarehousesLoad,
                name: 'load',
                meta: {
                    breadcrumb: [
                        {text: 'Inicio', to: '/dashboard'},
                        {text: 'Almacenes'}
                    ]
                }
            },
            {
                path: 'warehousesListsRex',
                component: MagatzemsRexpedicio,
                name: 'loalistRexd',
                meta: {
                    breadcrumb: [
                        {text: 'Inicio', to: '/dashboard'},
                        {text: 'Almacenes'}
                    ]
                }
            },
            {
                path: 'MagatzemsRexpedicioHibrid',
                component: MagatzemsRexpedicioHibrid,
                name: 'MagatzemsRexpedicioHibrid',
                meta: {
                    breadcrumb: [
                        {text: 'Inicio', to: '/dashboard'},
                        {text: 'Carga de híbridos'}
                    ]
                }
            },
            {
                path: 'clients',
                component: ClientsList,
                name: 'clients.index',
                meta: {
                    breadcrumb: [
                        {text: 'Inicio', to: '/dashboard'},
                        {text: 'Clientes'}
                    ]
                }
            },
            {
                path: 'providers',
                component: ProvidersList,
                name: 'providers.index'
            },

            {
                path: 'leads',
                component: () => import('@/views/admin/WebClient/Leads.vue'),
                name: 'webLeads.index',
                meta: {
                    roles: ['admin', 'gerencia', 'backoffice'],
                    breadcrumb: [{ text: 'Inicio', to: '/dashboard' }, { text: 'Leads' }]
                }
            },
            {
                path: 'inversion-seo-ads',
                component: () => import('@/views/admin/WebClient/InversionSeoAds.vue'),
                name: 'inversionSeoAds.index',
                meta: {
                    roles: ['admin', 'gerencia', 'backoffice'],
                    breadcrumb: [{ text: 'Inicio', to: '/dashboard' }, { text: 'Inversión SEO + ADS' }]
                }
            },
            // Web Client
            {
                path: 'pedidos-clientes-web',
                component: () => import('@/views/admin/WebClient/PedidosClientesWeb.vue'),
                name: 'pedidosClientesWeb.index',
                meta: {
                    roles: ['admin', 'gerencia', 'backoffice'],
                    breadcrumb: [
                        { text: 'Inicio', to: '/dashboard' },
                        { text: 'Pedidos clientes web' }
                    ]
                }
            },
            {
                path: 'CampaignWebList',
                component: AdminCampaignWebList,
                name: 'CampaignWebList'
            },


            // Estudis Qualitat web client
            {
                path: 'Documentacio/:tipus(\\d+)?',   // opcional i només dígits
                component: AdminDocumentacio,
                name: 'Documentacio'
            },

            // Planimetria
            {
                path: 'ReloadPlani',
                component: ReloadPlani,
                name: 'ReloadPlani',
                meta: {
                    breadcrumb: [
                        {text: 'Inicio', to: '/dashboard'},
                        {text: 'Recargar planimetria'}
                    ]
                }
            },
            {
                path: 'ValidarPlani',
                component: ValidarPlani,
                name: 'ValidarPlani',
                meta: {
                    breadcrumb: [
                        {text: 'Inicio', to: '/dashboard'},
                        {text: 'Validar planimetria'}
                    ]
                }
            },
            {
                path: 'EnviarPlani',
                component: EnviarPlani,
                name: 'EnviarPlani',
                meta: {
                    breadcrumb: [
                        {text: 'Inicio', to: '/dashboard'},
                        {text: 'Enviar planimetria'}
                    ]
                }
            },
            {
                path: 'AlbaransEntrega',
                component: AlbaransEntrega,
                name: 'AlbaransEntrega',
                meta: {
                    breadcrumb: [
                        {text: 'Inicio', to: '/dashboard'},
                        {text: 'Albaranes ET'}
                    ]
                }
            },
            {
                path: 'DescarregarPlaniXls',
                component: DescarregarPlaniXls,
                name: 'DescarregarPlaniXls',
                meta: {
                    breadcrumb: [
                        { text: 'Inicio', to: '/dashboard' },
                        { text: 'Descargar planificación XLS' }
                    ]
                }
            },

            {
                path: 'EntregasTienda',
                component: EntregasTienda,
                name: 'EntregasTienda',
                meta: {
                    breadcrumb: [
                        { text: 'Inicio', to: '/dashboard' },
                        { text: 'Entregas en tienda' }
                    ]
                }
            },
            {
                path: 'RepartosHoy',
                component: RepartosHoy,
                name: 'RepartosHoy',
                meta: {
                    breadcrumb: [
                        { text: 'Inicio', to: '/dashboard' },
                        { text: 'Repartos de hoy' }
                    ]
                }
            },
            {
                path: 'CampanyasIniciadasSinPlanificar',
                component: CampanyasIniciadasSinPlanificar,
                name: 'CampanyasIniciadasSinPlanificar',
                meta: {
                    breadcrumb: [
                        { text: 'Inicio', to: '/dashboard' },
                        { text: 'Campañas sin planificar' }
                    ]
                }
            },

            {
                path: 'client_info',
                component: ClientsInfoList,
                name: 'clientsInfo.index',
                meta: {
                    breadcrumb: [
                        {text: 'Inicio', to: '/dashboard'},
                        {text: 'Información de Clientes'}
                    ]
                }
            },

            {
                path: 'kpi',
                component: Kpis,
                name: 'KPI',
                meta: {
                    breadcrumb: [
                        {text: 'Inicio', to: '/dashboard'},
                        {text: 'KPI'}
                    ]
                }
            },
        ]
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

const getUserFromAPI = async () => {
    const token = localStorage.getItem('token')
    if (!token) return null

    try {
        const { data: user } = await axios.get('/api/user', {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
        return user
    } catch (error) {
        console.error('Error obtenint l\'usuari:', error)
        return null
    }
}

router.beforeEach(async (to) => {
    if (!to.meta.requiresAuth) return true
    const token = localStorage.getItem('token')
    if (!token) return { path: '/' }

    if (!to.meta.roles) return true

    const user = await getUserFromAPI()
    if (!user) return { path: '/' }
    return to.meta.roles.includes(user.role) ? true : { path: '/dashboard' }
})


export default router
